import React, { useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL || "https://sipedasapi.bkkpangkalpinang.com/api";

export default function LogBukuICVPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        // TODO: ganti endpoint sesuai backend kamu
        const { data } = await axios.get(`${API_URL}/logs/buku-icv`);
        if (alive) setRows(Array.isArray(data?.data) ? data.data : []);
      } catch (e) {
        console.error("Gagal load LOG Buku ICV:", e);
        if (alive) setRows([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => (alive = false);
  }, []);

  if (loading) return <div>Memuat LOG Buku ICV…</div>;

  return (
    <div className="card">
      <h2 style={{ marginBottom: 12 }}>LOG • Buku ICV</h2>
      {rows.length === 0 ? (
        <div>Tidak ada data.</div>
      ) : (
        <div className="table-wrap" style={{ overflowX: "auto" }}>
          <table className="table">
            <thead>
              <tr>
                <th>No</th>
                <th>Tanggal</th>
                <th>Nama</th>
                <th>No. ICV</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.id ?? i}>
                  <td>{i + 1}</td>
                  <td>{r.tanggal ?? "-"}</td>
                  <td>{r.nama ?? "-"}</td>
                  <td>{r.no_icv ?? "-"}</td>
                  <td>{r.aksi ?? "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
